<template>
    <div class="admin-dashboard-tansfer">
        <TransferList />
    </div>
</template>

<script>
import { mapActions } from "vuex";
import TransferList from "../components/TransferList";

export default {
    name: "AdminTransfer",
    components: {
        TransferList
    },
    data() {
        return {
            processing: false,
            showNew: false,
            showDetail: false,
            selectedData: null
        };
    },
    mounted() {
    },
    methods: {
        ...mapActions(["request", "getError"]),
    }
};
</script>
<style scoped>
</style>